import { type Scope, createContextScope } from '@radix-ui/react-context'
import type { CardInformativeProps } from './card-informative-types'
import * as C from './card-informative.styles'
import { CardInformativeContent } from './components/card-informative-content'
import { CardInformativeDescription } from './components/card-informative-description'
import { CardInformativeIcon } from './components/card-informative-icon'
import { CardInformativeTitle } from './components/card-informative-title'

export const DISPLAY_NAME = 'CardInformative'

type CardInformativeRootProps = CardInformativeProps & {
  children: React.ReactNode
}

const CardInformativeRoot = (props: CardInformativeRootProps) => {
  const { children, type, variants, iconName, testID, __scopeCardInformative } =
    props as ScopedProps<CardInformativeRootProps>

  const CardInformativeProviderProps = {
    type,
    variants,
    iconName,
    scope: __scopeCardInformative,
  } as CardInformativeProps & { scope: Scope }

  const componentProperties = {
    type,
    variants,
  }
  return (
    <CardInformativeProvider {...CardInformativeProviderProps}>
      <C.Root {...componentProperties} testID={testID}>
        {type !== 'text' && <CardInformativeIcon />}
        {children}
      </C.Root>
    </CardInformativeProvider>
  )
}

/*
----------------------------------------------------------------
Scope Definition
----------------------------------------------------------------
*/

export type ScopedProps<P> = P & {
  __scopeCardInformative?: Scope
}

type CardInformativeContext = CardInformativeProps

const [createCardInformativeContext] = createContextScope(DISPLAY_NAME)

export const [CardInformativeProvider, useCardInformativeContext] =
  createCardInformativeContext<CardInformativeContext>(DISPLAY_NAME)

export const CardInformative = {
  Root: CardInformativeRoot,
  Content: CardInformativeContent,
  Title: CardInformativeTitle,
  Description: CardInformativeDescription,
}
